import { render } from "./SimUserLimitMessage.vue?vue&type=template&id=2ee35af3&scoped=true"
import script from "./SimUserLimitMessage.vue?vue&type=script&lang=js"
export * from "./SimUserLimitMessage.vue?vue&type=script&lang=js"

import "./SimUserLimitMessage.vue?vue&type=style&index=0&id=2ee35af3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee35af3"]])

export default __exports__